/*
* Copyright (c) 2022 LS ELECTRIC Co. Ltd. All Reserved.
*/
/*******************************************************************
 * @author HyeonhJin Oh
 * @contact jhjoh@detech.co.kr
 * @date 2022-10-21
 * @brief EHP 서비스센터 개발
 *
 ********************************************************************/
import React from "react";
/**
 * @brief EHP 서비스 센터 컴포넌트
 * @param -
 * @returns react components
 */
function EhpServiceCenter(props) {
    return (React.createElement(React.Fragment, null,
        React.createElement("a", { href: "https://www.ls-electric.com/ko/service/info", className: "svcenter__Btn", target: "_blank" },
            React.createElement("span", { className: "hide" }, "\uC11C\uBE44\uC2A4\uC13C\uD130 \uBC14\uB85C\uAC00\uAE30"))));
}
export default EhpServiceCenter;
